import { isBrowser } from '@websolutespa/bom-core';
import { ReactNode, useEffect, useId, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLlmView } from '../../../useLlm/useLlmView';

export function Portals({ children, ...props }: {
  children: ReactNode;
  selector?: string;
  replace?: boolean;
}) {
  const portal = useLlmView(state => state.portal);
  const selector = props.selector || portal.selector;
  const replace = props.replace || portal.replace;

  const [portals, setPortals] = useState<Element[]>([]);

  function updatePortals() {
    const newPortals = Array.from(document.querySelectorAll(selector));
    newPortals.forEach(element => {
      if (!element.classList.contains('llm')) {
        element.classList.add('llm', 'llm__reset');
        if (replace) {
          element.innerHTML = '';
        }
      }
    });
    if (newPortals.length !== portals.length) {
      setPortals(newPortals);
    }
  }

  useEffect(() => {
    if (isBrowser) {
      updatePortals();
      const observer = new MutationObserver((mutations) => {
        updatePortals();
      });
      observer.observe(document, {
        childList: true,
        subtree: true,
      });
      return () => {
        observer?.disconnect();
      };
    } else {
      return () => { };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector, replace]);

  return portals.map((element, i) => (
    <Portal key={i} target={element}>
      {children}
    </Portal>
  ));
}

export function Portal({ children, target }: { children: ReactNode, target: Element }) {
  const id = useId();
  // console.log('Portal', target, id);
  return createPortal(children, target, id);
}
